/**
 * Error Banner Component
 *
 * Displays an error message in a styled alert container.
 *
 * @see {@link ./__tests__/error-banner.test.tsx}
 */

interface ErrorBannerProps {
  error?: string | null
}

export const ErrorBanner = ({ error }: ErrorBannerProps): JSX.Element | null => {
  if (!error) return null

  return (
    <div role="alert" className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
      {error}
    </div>
  )
}
